import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { DesktopBreadcrumb } from "../app/desktopTopNav/DesktopBreadcrumb";
import type { AskedFrom } from "../../domains/gpt/askedFrom";

/**
 * Where a desktop conversation sits: under the JuisciGPT landing, or under the
 * page its question was asked from (Explore, for a Quick task question). Back
 * returns to that first crumb.
 */
export function GptConversationBreadcrumb({
  askedFrom,
  newChatLink,
  onBackToGpt,
  current,
}: {
  askedFrom: AskedFrom;
  newChatLink: string;
  onBackToGpt: () => void;
  current: string;
}): React.JSX.Element {
  const { t } = useTranslation();
  const history = useHistory();
  if (askedFrom === null)
    return (
      <DesktopBreadcrumb
        back={{ kind: "first-crumb", onBack: onBackToGpt }}
        trail={[{ label: "JuisciGPT", to: newChatLink }]}
        current={current}
      />
    );
  switch (askedFrom.kind) {
    case "explore":
      return (
        <DesktopBreadcrumb
          back={{
            kind: "first-crumb",
            onBack: () => {
              history.push(askedFrom.path);
            },
          }}
          trail={[{ label: t("Explore"), to: askedFrom.path }]}
          current={current}
        />
      );
    default:
      throw new Error(askedFrom.kind satisfies never);
  }
}
